"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalSlices = void 0;
const Slices_1 = require("./Slices");
class LocalSlices extends Slices_1.Slices {
    del(id) {
        super.del(id);
        if (Math.random() < 0.1)
            this.set.rmTombstones();
    }
    toStringName() {
        return 'LocalSlices';
    }
}
exports.LocalSlices = LocalSlices;
